import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createRef, Component } from 'react';
import { propFunc, propShape, propStr, } from '../../../helpers/custom-prop-types';
import { getFormValue } from '../../../helpers/form';
import { baseSkillLevels, getBaseSkillBorderClassName, } from '../../../helpers/profile';
import PlainInputField from '../Common/Fields/PlainInputField';
import SplitText from '../Common/SplitText';
class BaseSkillFieldsAndLabel extends Component {
    constructor(props) {
        super(props);
        this.onClickList = (e) => {
            e.stopPropagation();
            const { change, name, size } = this.props;
            const isPc = size === 'pc';
            const pos = isPc ? e.nativeEvent.clientX : e.nativeEvent.clientY;
            const rect = this.border.current.getClientRects()[0];
            const min = isPc ? rect.left : rect.bottom;
            const max = isPc ? rect.right : rect.top;
            const borderWidth = isPc ? max - min : min - max;
            const borderSingle = borderWidth / (baseSkillLevels.length - 1);
            const current = isPc ? pos - min : min - pos;
            const setLevel = Math.round(current / borderSingle) + 1;
            change(name, setLevel);
        };
        this.onDragStart = (e) => {
            if (e.dataTransfer.setDragImage) {
                e.dataTransfer.setDragImage(this.transfer.current, 0, 0);
            }
            const rect = this.border.current.getClientRects()[0];
            this.minX = rect.left;
            this.maxX = rect.right;
            const btnRect = this.drag.current.getClientRects()[0];
            this.startX = btnRect.left;
            this.moveX = 0;
        };
        this.onDrag = (e) => {
            if (e.clientY === 0) {
                return;
            }
            this.setMoveX(e);
            this.drag.current.style.transform = `translateX(${this.moveX}px)`;
        };
        this.onDragEnd = (e) => {
            // ie用
            this.setMoveX(e);
            const { change, name } = this.props;
            const borderWidth = this.maxX - this.minX;
            const borderSingle = borderWidth / (baseSkillLevels.length - 1);
            const currentX = this.startX + this.moveX - this.minX;
            const setLevel = Math.round(currentX / borderSingle) + 1;
            this.drag.current.style.transform = 'translateX(0)';
            change(name, setLevel);
        };
        this.setMoveX = (e) => {
            let posX = e.clientX;
            if (posX > this.maxX) {
                posX = this.maxX;
            }
            else if (posX < this.minX) {
                posX = this.minX;
            }
            this.moveX = posX - this.startX;
        };
        this.border = createRef();
        this.drag = createRef();
        this.transfer = createRef();
        this.startX = null;
        this.moveX = null;
        this.minX = null;
        this.maxX = null;
    }
    render() {
        const { label, maxDescription, minDescription, name, normalDescription, size, thisForm, } = this.props;
        const currentValue = getFormValue(thisForm, name);
        return (_jsxs("div", Object.assign({ className: 'research-list' }, { children: [_jsx(PlainInputField, { name: name, showError: false, type: 'hidden' }), _jsx("p", Object.assign({ className: 'research-title' }, { children: label })), _jsxs("div", Object.assign({ className: 'progress-box' }, { children: [_jsxs("div", Object.assign({ className: 'next-progress-bar-wrapper' }, { children: [_jsx("ol", Object.assign({ className: 'next-progress-bar', onClick: this.onClickList, ref: this.border, role: 'presentation' }, { children: baseSkillLevels.map((level) => (_jsx("li", { className: getBaseSkillBorderClassName(level, currentValue) }, level))) })), _jsx("button", { "aria-label": 'skill', className: `next-progress-btn pos${currentValue}-9`, draggable: size === 'pc', onDrag: this.onDrag, onDragEnd: this.onDragEnd, onDragStart: this.onDragStart, ref: this.drag, type: 'button' }), _jsx("div", { className: 'next-progress-btn-dummy', ref: this.transfer })] })), _jsxs("ul", Object.assign({ className: 'progress-text' }, { children: [_jsx("li", { children: _jsx(SplitText, { className: 'keep-all-wrap', text: minDescription, wrap: 'p' }) }), _jsx("li", { children: _jsx(SplitText, { className: 'is-nowrap', text: normalDescription, wrap: 'p' }) }), _jsx("li", { children: _jsx(SplitText, { className: 'keep-all-wrap', text: maxDescription, wrap: 'p' }) })] }))] }))] })));
    }
}
BaseSkillFieldsAndLabel.propTypes = {
    change: propFunc().isRequired,
    label: propStr().isRequired,
    maxDescription: propStr().isRequired,
    minDescription: propStr().isRequired,
    name: propStr().isRequired,
    normalDescription: propStr().isRequired,
    size: propStr().isRequired,
    thisForm: propShape().isRequired,
};
export default BaseSkillFieldsAndLabel;
